const API_BASE =
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_API ||
  (typeof window !== "undefined" &&
  window.location.hostname.includes("onrender.com")
    ? "https://cvanto-api.onrender.com"
    : "http://localhost:5000");

const WEB_SESSION_URL = `${API_BASE}/api/web-session`;
const SESSION_FLAG_KEY = "cvanto:webSessionSent";

// Fires once per real browser tab session (not per SPA route change — App
// only mounts once per actual page load, client-side navigation never
// remounts it) and once per tab even across StrictMode's dev-only double
// invoke, via a sessionStorage guard. No auth required and no PII sent —
// see server/routes/webSession.js for what's actually stored.
export function sendWebSessionBeacon() {
  try {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(SESSION_FLAG_KEY)) return;
    sessionStorage.setItem(SESSION_FLAG_KEY, "1");
  } catch {
    // sessionStorage unavailable (private mode, etc.) — fall through and
    // send once for this call; worst case a refresh double-counts, which
    // is an acceptable tradeoff over losing the visit entirely.
  }

  let referrerHost = null;
  try {
    referrerHost = document.referrer ? new URL(document.referrer).hostname : null;
  } catch {
    referrerHost = null;
  }

  fetch(WEB_SESSION_URL, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ referrerHost }),
  }).catch(() => {});
}
